import { render, staticRenderFns } from "./refundOrderList.vue?vue&type=template&id=36ebc322&scoped=true"
import script from "./refundOrderList.vue?vue&type=script&lang=js"
export * from "./refundOrderList.vue?vue&type=script&lang=js"
import style0 from "./refundOrderList.vue?vue&type=style&index=0&id=36ebc322&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ebc322",
  null
  
)

export default component.exports